import AgentPrompt from "../../../../contents/docs/integrate/_snippets/agent-prompt.mdx";
import DetailSetUpReverseProxy from "../../../../contents/docs/integrate/_snippets/details/set-up-reverse-proxy.mdx";
import DetailGroupProductsInOneProject from "../../../../contents/docs/integrate/_snippets/details/group-products-in-one-project.mdx";
import DetailPostHogIPs from "../../../../contents/docs/integrate/_snippets/details/posthog-ips.mdx";
import * as React from 'react';
export default {
  AgentPrompt,
  DetailSetUpReverseProxy,
  DetailGroupProductsInOneProject,
  DetailPostHogIPs,
  React
};